import {useCallback, useState} from "react";

type useErrorableStateT<T> = [T | undefined, (v?: T) => void, string | undefined, (err?: string) => void];

export default function useErrorableState<T>(initialValue?: T): useErrorableStateT<T> {
  const [value, _setValue] = useState(initialValue);
  const [error, setError] = useState<string | undefined>(undefined);

  const setValue = useCallback(
    (value: T | undefined) => {
      setError(undefined);
      _setValue(value);
    },
    [setError, _setValue],
  );

  return [value, setValue, error, setError];
}
